module.exports = __webpack_public_path__ + "img/pro.9029bc16.png";